import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../../../theme';

import { ExchangeRefundContentWrapper, ExchangeRefundSelectControl } from '@entities/order';
import {
	getSegmentsControls,
	getIsAllSegmentsSelected,
	setAllSegmentsSelect,
	setSegmentDate,
	setSegmentSelect
} from '@entities/exchange';
import { SelectDate } from '@features/exchange/select-date';
import { CdnIcon } from '@shared/ui';
import { ExchangeControlsWrapper } from '@features/exchange/exchange-route-controls/ui';

const Segments: React.FC = () => {
	const { t } = useTranslation('Exchange');
	const { Segments: segmentsTheme } = useTheme('Widgets').Exchange;

	const dispatch = useDispatch();

	const segmentsControls = useSelector(getSegmentsControls);
	const isAllSegmentsSelected = useSelector(getIsAllSegmentsSelected);

	const onToggleAllSegments = (selected: boolean) => {
		dispatch(setAllSegmentsSelect(selected));
	};

	const onChangeSelect = (id: string) => (selected: boolean) => {
		dispatch(setSegmentSelect({ id, selected }));
	};

	const onSetSegmentDate = (id: string) => (date: Date) => {
		dispatch(setSegmentDate({ id, date }));
	};

	return (
		<ExchangeRefundContentWrapper width="sm" icon={<CdnIcon icon="Flight/Direction" />} title={t('Segments.Title')}>
			<ExchangeControlsWrapper>
				{segmentsControls.length > 1 && (
					<ExchangeRefundSelectControl
						label={t('Segments.AllSegments')}
						isSelected={isAllSegmentsSelected}
						onChange={onToggleAllSegments}
					/>
				)}
				{segmentsControls.map(segment => (
					<ExchangeRefundSelectControl
						key={`${segment.id}/${isAllSegmentsSelected}`}
						classes={{ label: segmentsTheme.label }}
						label={
							<>
								{segment.label}
								<SelectDate
									date={segment.selectedDate}
									minDate={segment.minDate}
									selectedDates={segment.selectedDates}
									segmentSearchParams={segment.segmentSearchParams}
									isOpen={segment.isOpen}
									isSelected={segment.isSelected}
									onSelectDate={onSetSegmentDate(segment.id)}
								/>
							</>
						}
						isSelected={segment.isSelected}
						onChange={onChangeSelect(segment.id)}
					/>
				))}
			</ExchangeControlsWrapper>
		</ExchangeRefundContentWrapper>
	);
};

export default Segments;
